export class CourseCopyBtn {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;

    this.hideClassName = this.node.dataset.hideClass;
  }

  show() {
    this.node.classList.remove(this.hideClassName);
  }

  hide() {
    this.node.classList.add(this.hideClassName);
  }

  setParams() {
    // ボタンのdata属性をセットする
    this.node.dataset.jcPlanStartSpotId =
      this.app.getState('mixInfo')['jtp_start_spot_id'];
    this.node.dataset.jcPlanModes = this.app.getState('mixInfo')['jtp_modes'];
    this.node.dataset.jcPlanSpotIds = this.app.getState('mixInfo')['jtp_spot_ids'].toString();
  }

  render() {
    this.hide();

    // fetch終了かつ有効なスポット情報があれば
    if (
      !this.app.getState('isFetching') &&
      this.app.getState('hasValidSpotData')
    ) {
      this.setParams();
      this.show();
    }
  }
}
